enum ProductTrackingNames {
  perks = "perks",
  recognition = "recognition",
  medical = "medical",
  wellness = "wellness",
  home = "home",
  wallet = "wallet",
  account = "my account",
  notifications = "notifications",
  rewards = "rewards",
  culturehub = "culturehub",
  myperkbox = "my-perkbox",
  savings = "savings",
  he = "he",
  alp = "alp",
  ctw = "ctw",
}

export default ProductTrackingNames
